import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sd-bottom-sheet-header',
  templateUrl: './bottom-sheet-header.component.html'
})
export class BottomSheetHeaderComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
